import React from "react";
import { SupplementOptions } from "./AddSupplementsToDishModal";
import { buildTranslationTextVm } from "../../../utils/translationVersions/buildTranslationTextVm";
import TranslationMissingDot from "../../../components/LanguageVersionSelect/TranslationMissingDot";

interface RenderGroupLabelProps {
    name: string;
    nameOrigin?: string | null;
    options: SupplementOptions[];
    currencySign?: string;
    isTranslationMode: boolean;
    tooltipText: string;
}

export const RenderGroupLabel: React.FC<RenderGroupLabelProps> = ({
    name,
    nameOrigin,
    options,
    currencySign,
    isTranslationMode,
    tooltipText,
}) => {
    const groupNameVm = buildTranslationTextVm({
        translatedValue: name,
        originValue: nameOrigin,
        isTranslationMode,
    });

    if (!options?.length) {
        return (
            <p className="text-dark mb-0">
                <span className="me-1">{groupNameVm.displayText}</span>
                {groupNameVm.isMissingTranslation ? <TranslationMissingDot tooltipText={tooltipText} /> : null}
            </p>
        );
    }

    return (
        <p className="text-dark mb-0 d-inline">
            <span className="me-1">{groupNameVm.displayText}</span>
            {groupNameVm.isMissingTranslation ? <TranslationMissingDot tooltipText={tooltipText} /> : null}(
            {options.map((opt, index) => {
                const optionNameVm = buildTranslationTextVm({
                    translatedValue: opt.name,
                    originValue: opt.nameOrigin,
                    isTranslationMode,
                });

                return (
                    <span key={opt.id} className="d-inline-flex align-items-center">
                        <span className="me-1">{optionNameVm.displayText}</span>
                        {optionNameVm.isMissingTranslation ? <TranslationMissingDot tooltipText={tooltipText} /> : null}
                        {opt.price != null && opt.price !== 0 && (
                            <span className="fw-bold ms-1">
                                +{opt.price} {currencySign}
                            </span>
                        )}
                        {index < options.length - 1 && <span className="me-1">;</span>}
                    </span>
                );
            })}
            )
        </p>
    );
};
